require('./cardsBox.scss');

// @vendor
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const React = require('react');
const { withRouter } = require('react-router-dom');
const classnames = require('classnames');
const includes = require('lodash/collection/includes');
const some = require('lodash/collection/some');
const { connect } = require('react-redux');

// @actions
const signaturePatternActions = require('actions/signaturePattern');
const transactionActions = require('actions/getCardsTransactions');

// @commons
const { Accordion } = require('commonsComponents/accordion');
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');

// @components
const { CardsBoxHeader } = require('./cardsBoxHeader/cardsBoxHeader');
const CardsBoxBody = require('./cardsBoxBody/cardsBoxBody');

// @constants
const { INACTIVE_STATUS_LIST, CANCELLED_STATUS } = require('constants/contactCenter/cardStatus');


class CardsBox extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleOnClick = this.handleOnClick.bind(this);
        this.handleBoxClick = this.handleBoxClick.bind(this);
        this.setNode = this.setNode.bind(this);
    }

    setNode(ref) {
        this.nodeReference = ref;
    }

    handleBoxClick(evt) {
        if (!!this.nodeReference && !this.nodeReference.contains(evt.target)) {
            // THIS IS TO PREVENT AN UNEXPECTED BEHAVIOR,
            // WHEN CLICKING ON MODAL CUSTOM(cardsControlButton), THIS CLICK HANDLER FIRES ALTHOUGH CARDS BOX ELEMENT IS NOT PARENT OF MODAL CUSTOM
            // THIS ISSUE APPEARED AFTER UPGRADING TO REACT 16
            return;
        }

        const { history, immCard } = this.props;
        const cardId = immCard.get('cardId');
        const linkToMovements = `/myprofile/cards/${cardId}/movements`;
        const classListWithoutRedirect = [
            'glb-position-showmore', // Mas movimientos
            'buttons-base-old', // Activar (leave for consistency)
            'buttons-base', // Activar (leave for consistency)
            'cards-box-header__activate-button', // Container de link Activar
            'ok-link-button-old', // Detalles (leave for consistency)
            'ok-link-button', // Detalles
            'toggle', // Apagar temporalmente
            'cards-box-header__charge-button', // Cargar
            'ok-collapsing-toggler', // Colapsar
            'buttons-base__children', // Activar
            'card-box-header__active-button', // Another Activar button
            'cards-toggle-button__description-container'
        ];

        if (!some(evt.target.parentElement.classList, (el) => includes(classListWithoutRedirect, el))) {
             history.push(linkToMovements);
        }
    }

    handleOnClick(isExpanded) {
        const { cardIndex } = this.props;
        this.props.onClick(isExpanded, cardIndex);
    }

    render() {
        const {
            cardIndex,
            expanded,
            flagBasedFeatures,
            immCard,
            immCardsTransactions,
            immCommercialAds,
            immProfile,
            requestCardTransactions,
            validateAndExecuteSagas,
        } = this.props;
        const isCancelled = immCard.get('cancelled');
        const canBeExpanded = immCard.get('active');

        let isExpanded = expanded;
        if (cardIndex === 0) {
            isExpanded = expanded && canBeExpanded;
        }

        const statusCard = immCard.get('cancelled') ? CANCELLED_STATUS : immCard.get('status');
        const cardBoxClasses = classnames('cards-box', {
            'cards-box--is-expanded': isExpanded,
            'cards-box--disabled': !__CONTACT_CENTER__ ? isCancelled : INACTIVE_STATUS_LIST.includes(statusCard),
            'cards-box--is-clickable': !isExpanded
        });
        const typeCard = immCard.getIn(['contract', 'product']);
        const subTypeCard = immCard.getIn(['criteria', 'c1', 'subtipoproducto']);
        const standardCodeCard = immCard.getIn(['criteria', 'c1', 'estand']).slice(-3);
           return (
            <div
                className={cardBoxClasses}
                onClick={!isExpanded && this.handleBoxClick}
                ref={this.setNode}
            >
                <Accordion onClick={this.handleOnClick} isExpanded={isExpanded}>
                    <AccordionHeader name="AccordionHeader" canBeExpanded={canBeExpanded}>
                        <CardsBoxHeader
                            immCard={immCard}
                            immCommercialAds={immCommercialAds}
                            cardIndex={cardIndex}
                            expanded={isExpanded}
                        />
                    </AccordionHeader>
                    <AccordionBody name="AccordionBody">
                        <CardsBoxBody
                            cardIndex={cardIndex}
                            flagBasedFeatures={flagBasedFeatures}
                            immCard={immCard}
                            immCardsTransactions={immCardsTransactions}
                            immProfile={immProfile}
                            requestCardTransactions={requestCardTransactions}
                            validateAndExecuteSagas={validateAndExecuteSagas}
                        />
                    </AccordionBody>
                </Accordion>
            </div>
        );
    }
}

CardsBox.propTypes = {
    cardIndex: PropTypes.number,
    expanded: PropTypes.bool,
    flagBasedFeatures: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    immCard: PropTypes.object,
    immCardsTransactions: PropTypes.object,
    immCommercialAds: PropTypes.object.isRequired,
    immProfile: PropTypes.object,
    onClick: PropTypes.func,
    requestCardTransactions: PropTypes.func,
    validateAndExecuteSagas: PropTypes.func.isRequired,
};

module.exports.constructor = CardsBox;
module.exports.CardsBox = connect(state => ({
    flagBasedFeatures: state.flagBasedFeatures,
}), {
        requestCardTransactions: transactionActions.requestCardTransactions,
        validateAndExecuteSagas: signaturePatternActions.validateAndExecuteSagas,
    }
)(withRouter(CardsBox));
